import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const FallbackContainer = styled.div`
    max-height: 0;
    margin: -${SPACING.SMALL};
`;
